var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { key: "loading", staticClass: "flex justify-center" }, [
          _vm._m(0),
        ])
      : _c(
          "div",
          { staticClass: "flex flex-col mt-md" },
          [
            _c(
              "div",
              { staticClass: "grid gap-y-lg xs:gap-md grid-cols-12" },
              _vm._l(_vm.mainRecipes, function (item) {
                return _c(
                  "div",
                  {
                    key: item.item.slug,
                    staticClass: "col-span-12 xs:col-span-4",
                  },
                  [
                    _c("recipeitem", {
                      attrs: { content: item.item, tags: item.tags },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.sideRecipes.length
              ? [
                  _c(
                    "span",
                    {
                      staticClass:
                        "font-semibold mt-lg mb-sm text-primary-400 inline-flex items-center gap-xs xl:pointer-events-none",
                    },
                    [_vm._v("Tussendoortjes & desserts")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-md bg-gray-700" }, [
                    _c(
                      "div",
                      { staticClass: "grid gap-y-lg xs:gap-md grid-cols-12" },
                      _vm._l(_vm.sideRecipes, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.item.slug,
                            staticClass: "col-span-12 lg:col-span-6",
                          },
                          [
                            _c("recipesideitem", {
                              attrs: { content: item.item, tags: item.tags },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "aspect-[320/480] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
      },
      [
        _c("i", {
          staticClass:
            "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }